import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FormsAdapter } from './forms.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccFormsAdapter implements FormsAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  postAdvancedForm(url: string, body: HttpParams): Observable<any> {
    return this.http
      .post(url, body, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  postAdvancedFormFile(url: string, body: FormData): Observable<string> {
    return this.http
      .post(url, body, { responseType: 'text' })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
